import { useTranslation } from "react-i18next";
import { Area, AreaChart, CartesianGrid, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TrendingUp } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

const TOOLTIP = {
  background: "hsl(var(--popover))",
  border: "1px solid hsl(var(--border))",
  borderRadius: 14,
  color: "hsl(var(--foreground))",
  direction: "ltr",
};

export const TrendCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <NeuCard
      data-testid="system-trend-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-primary" /> {t("system.trends", { days: data.days })}
      </p>

      <div className="mt-5 h-64 w-full min-w-0" dir="ltr">
        {!data.points.length ? (
          <p className="text-sm text-muted-foreground" data-testid="system-trend-empty">
            {t("system.geoEmpty")}
          </p>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data.points}>
              <defs>
                <linearGradient id="reqFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={0.5} />
                  <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0.04} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis dataKey="date" stroke="hsl(var(--muted-foreground))" fontSize={10} />
              <YAxis yAxisId="left" stroke="hsl(var(--muted-foreground))" fontSize={10} allowDecimals={false} />
              <YAxis yAxisId="right" orientation="right" stroke="hsl(var(--muted-foreground))" fontSize={10} />
              <Tooltip contentStyle={TOOLTIP} />
              <Area
                yAxisId="left"
                type="monotone"
                dataKey="requests"
                name={t("system.requests")}
                stroke="hsl(var(--primary))"
                strokeWidth={2}
                fill="url(#reqFill)"
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="avg_ms"
                name={t("system.avgMs")}
                stroke="hsl(var(--destructive))"
                strokeWidth={2}
                dot={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </NeuCard>
  );
};
